'use strict';
exports.opening = require('./opening');
exports.closing = require('./closing');



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/omission/index.js
// module id = 179
// module chunks = 96961042003272 139266963665775